export const isNotEmpty = <T>(array?: T[] | null | T): array is Array<T> => {
  return Array.isArray(array) && array.length > 0;
};
export const isEmpty = <T>(array?: T[] | null | T) => {
  return !isNotEmpty(array);
};
/**
 * 合并左右数组 类似于 concat
 * @param left
 * @param right
 */
export const merge = <T>(left?: Array<T>, right?: Array<T>) => {
  if (!Array.isArray(right) || right.isEmpty()) {
    return left;
  }
  if (!Array.isArray(left) || left.isEmpty()) {
    return right;
  }
  return left.concat(right);
};
/**
 * 行列互换
 * @param array 要交换行列的二维数组
 */
export const exchangeAxis = <T>(array: T[][]) => {
  // 新数组的的最大行数
  const size = array.max((it) => it.length);
  const rows = Array.from(Array(size)).map((_) =>
    Array.from(Array(array.length))
  );
  array.forEach((row, rowIndex) => {
    row.forEach((cell, columnIndex) => {
      rows[columnIndex][rowIndex] = cell;
    });
  });
  return rows;
};

export const isSingleTypeArray = <T>(
  array?: null | T | Array<T | Array<T>>
): array is Array<T> => {
  if (!Array.isArray(array)) {
    return false;
  }
  return array.every((it) => !Array.isArray(it));
};
export const isTowDimensionArray = <T>(
  array?: null | T | Array<T | Array<T>>
): array is Array<Array<T>> => {
  if (!Array.isArray(array)) {
    return false;
  }
  return array.every((it) => Array.isArray(it));
};
export default {
  isNotEmpty,
  isEmpty,
  merge,
  exchangeAxis,
  isSingleTypeArray,
  isTowDimensionArray,
};
